import React from 'react';
import { Box } from '@mui/material';

/**
 * Standard page wrapper for dashboard pages.
 *
 * - `header` slot: fixed-height area for title, breadcrumbs, action buttons, etc.
 * - `children`: body area that grows to fill remaining viewport height.
 *   Cards placed here can use `flex: 1` to fill the body, or stack normally
 *   and let the body scroll when content overflows.
 */
export default function PageLayout({ header, children }) {
  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      {header && (
        <Box sx={{ mb: 2, flexShrink: 0 }}>{header}</Box>
      )}
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
        {children}
      </Box>
    </Box>
  );
}
